import * as AC from '../actions/actionTypes';
import {updateObject} from '../utils/utilities';

const intitialState = {
  buildingGarages: [],
  buildingGaragesPage: 1,
  buildingGaragesTotalPages: 1,
  garagesLoading: false,
  garagesError: '',
  customerGarages: [],
  customerGaragesLoading: false,
  customerGaragesError: '',
  garageReport: [],
  garageReportPage: 1,
  garageReportTotalPages: 1,
  garageReportLoading: false,
  garageReportBuildings: [],
  garageReportGarages: [],
  garageReportFiltersLoading: false,
};

const garagesReducer = (state = intitialState, action) => {
  switch (action.type) {
    case AC.GET_BUILDING_GARAGES_REQUEST:
    case AC.ADD_GARAGE_REQUEST:
    case AC.EDIT_GARAGE_REQUEST:
    case AC.DELETE_GARAGE_REQUEST:
      return updateObject(state, {garagesLoading: true, garagesError: ''});
    case AC.GET_BUILDING_GARAGES_SUCCEED:
      return updateObject(state, {
        buildingGarages: action.payload,
        buildingGaragesPage: action.page,
        buildingGaragesTotalPages: action.totalPages,
        garagesLoading: false,
      });
    case AC.ADD_GARAGE_SUCCEED:
    case AC.EDIT_GARAGE_SUCCEED:
    case AC.DELETE_GARAGE_SUCCEED:
      return updateObject(state, {garagesLoading: false, garagesError: ''});
    case AC.GET_BUILDING_GARAGES_FAILED:
    case AC.ADD_GARAGE_FAILED:
    case AC.EDIT_GARAGE_FAILED:
    case AC.DELETE_GARAGE_FAILED:
      return updateObject(state, {
        garagesError: action.payload,
        garagesLoading: false,
      });

    case AC.GET_CUSTOMER_GARAGES_REQUEST:
    case AC.ADD_CUSTOMER_GARAGE_REQUEST:
    case AC.EDIT_CUSTOMER_GARAGE_REQUEST:
    case AC.DELETE_CUSTOMER_GARAGE_REQUEST:
      return updateObject(state, {
        customerGaragesLoading: true,
        customerGaragesError: '',
      });
    case AC.GET_CUSTOMER_GARAGES_SUCCEED:
      return updateObject(state, {
        customerGarages: action.payload,
        customerGaragesLoading: false,
      });
    case AC.ADD_CUSTOMER_GARAGE_SUCCEED:
    case AC.EDIT_CUSTOMER_GARAGE_SUCCEED:
    case AC.DELETE_CUSTOMER_GARAGE_SUCCEED:
      return updateObject(state, {
        customerGaragesLoading: false,
        customerGaragesError: '',
      });
    case AC.GET_CUSTOMER_GARAGES_FAILED:
    case AC.ADD_CUSTOMER_GARAGE_FAILED:
    case AC.EDIT_CUSTOMER_GARAGE_FAILED:
    case AC.DELETE_CUSTOMER_GARAGE_FAILED:
      return updateObject(state, {
        customerGaragesError: action.payload,
        customerGaragesLoading: false,
      });
    case AC.GET_GARAGE_REPORT_REQUEST:
      return updateObject(state, {garageReportLoading: true});
    case AC.GET_GARAGE_REPORT_SUCCEED:
      return updateObject(state, {
        garageReport: action.payload,
        garageReportPage: action.page,
        garageReportTotalPages: action.totalPages,
        garageReportLoading: false,
      });
    case AC.GET_GARAGE_REPORT_FAILED:
      return updateObject(state, {garageReportLoading: false});
    case AC.GET_GARAGE_REPORT_FILTERS_REQUEST:
      return updateObject(state, {garageReportFiltersLoading: true});
    case AC.GET_GARAGE_REPORT_FILTERS_SUCCEED:
      return updateObject(state, {
        garageReportBuildings: action.payload.buildings || [],
        garageReportGarages: action.payload.garages || [],
        garageReportFiltersLoading: false,
      });
    case AC.GET_GARAGE_REPORT_FILTERS_FAILED:
      return updateObject(state, {garageReportFiltersLoading: false});
    default:
      return state;
  }
};

export default garagesReducer;
